import { useState } from "react";
import { toast } from "sonner";
import { p } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { MessageSquare, X } from "lucide-react";

/** Cucina e pizzeria si mettono d'accordo sul tavolo: «pronti fra 5 minuti», «aspettate»,
 *  «mandate pure». Serve a far uscire insieme i piatti dello stesso tavolo. */
export const ParlaReparto = ({ dept, riga, by, onClose }) => {
  const { departments } = useApp();
  const altri = (departments || []).filter((d) => d !== dept);
  const [a, setA] = useState(altri[0] || "");
  const [busy, setBusy] = useState(false);

  const manda = async (kind, minutes = 0) => {
    if (!a) return;
    setBusy(true);
    try {
      await p("/kds/segnale", {
        from_dept: dept, to_dept: a, kind, minutes, by,
        order_id: riga?.order_id || "",
        table: riga ? (riga.group_name || (riga.tables || []).join(", ")) : "",
      });
      toast.success(`Detto a ${a}`);
      onClose?.();
    } catch {
      toast.error("Messaggio non partito");
    } finally {
      setBusy(false);
    }
  };

  if (!altri.length) return null;

  return (
    <div className="mt-2 rounded-lg border-2 border-sky-300 bg-sky-50 p-2.5" data-testid="parla-reparto">
      <div className="flex items-center justify-between gap-2">
        <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-sky-900">
          <MessageSquare className="h-3.5 w-3.5" /> Parla con
        </p>
        {onClose && (
          <button onClick={onClose} data-testid="parla-chiudi" className="text-sky-700">
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>

      <div className="mt-1.5 flex flex-wrap gap-1.5">
        {altri.map((d) => (
          <button
            key={d}
            onClick={() => setA(d)}
            data-testid={`parla-a-${d.toLowerCase().replace(/\s+/g, "-")}`}
            className={`h-8 rounded-md border px-2.5 text-xs font-semibold ${
              a === d ? "border-sky-700 bg-sky-700 text-white" : "border-sky-200 bg-white text-sky-900"
            }`}
          >
            {d}
          </button>
        ))}
      </div>

      <div className="mt-2 flex flex-wrap gap-1.5">
        {[["pronto_fra", "Pronti fra 5 min", 5], ["pronto_fra", "Pronti fra 10 min", 10],
          ["aspetta", "Aspettate", 0], ["manda_ora", "Mandate pure", 0], ["insieme", "Usciamo insieme", 0]]
          .map(([kind, label, min]) => (
            <button
              key={label}
              disabled={busy}
              onClick={() => manda(kind, min)}
              data-testid={`parla-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="h-9 rounded-md bg-white px-2.5 text-xs font-bold text-sky-900 ring-1 ring-sky-200 disabled:opacity-50"
            >
              {label}
            </button>
          ))}
      </div>
    </div>
  );
};
